// src/Auth/PreloginFirstGate.tsx
import { useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthProvider";

const PUBLIC_ALLOW: RegExp[] = [
    /^\/prelogin$/i,
    /^\/password$/i,
    /^\/error/i,
    /^\/unauthorized/i,
    /^\/forgot/i,
];

const REDIRECT_URI_KEY = "redirectUri";

export default function PreloginFirstGate(): JSX.Element | null {
    const auth = useContext(AuthContext);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            await auth.onReady?.();

            const path = location.pathname || "/";
            const search = location.search || "";
            const hash = location.hash || "";
            const fullPath = path + search + hash;

            const isAuth = auth.isAuthenticated();
            const isOboRoute = /^\/onbehalfof(\/|$)/i.test(path);

            console.log("[PreloginFirstGate] start", {
                path,
                search,
                hash,
                fullPath,
                isAuth,
                isOboRoute,
            });

            // Already authenticated → let route render
            if (isAuth) {
                console.log(
                    "[PreloginFirstGate] authenticated; letting route render",
                    { path }
                );
                return;
            }

            // OBO entry URL → let it through unauthenticated so OnBehalfOf can validate oboToken
            if (isOboRoute) {
                console.log(
                    "[PreloginFirstGate] unauthenticated OBO route; letting it through",
                    { path }
                );
                return;
            }

            const isPublic = PUBLIC_ALLOW.some((rx) => rx.test(path));
            console.log("[PreloginFirstGate] unauthenticated route check", {
                path,
                isPublic,
                publicPatterns: PUBLIC_ALLOW.map((r) => r.toString()),
            });

            if (isPublic) {
                console.log(
                    "[PreloginFirstGate] letting unauthenticated public route through",
                    { path }
                );
                return;
            }

            // Non-public + unauthenticated → go to /prelogin and remember where we wanted to go
            try {
                localStorage.setItem(REDIRECT_URI_KEY, fullPath || "/");
                console.log(
                    "[PreloginFirstGate] redirecting to /prelogin; storing redirectUri",
                    { redirectUri: fullPath || "/" }
                );
            } catch (e) {
                console.warn(
                    "[PreloginFirstGate] failed to store redirectUri; still redirecting to /prelogin",
                    e
                );
            }

            navigate("/prelogin", { replace: true });
        })();
    }, [auth, location, navigate]);

    return null;
}
